module.exports = "td{\r\n    border: 1px solid #ccc\r\n}\r\n\r\n.issuealert{\r\n    background: #fbd7d7;\r\n    }\r\n\r\n.issue{\r\n    background: #d5ded6eb;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing-details/unify-marketing-details-grid/unify-marketing-details-grid.component.css
// module id = ./src/app/prospect/unify-marketing-details/unify-marketing-details-grid/unify-marketing-details-grid.component.css
// module chunks = main